<p-dialog [(visible)]="displayExceptionDialog" [modal]="true" [style]="{width: '65vw', 'margin-top': '-15vh'}" (onHide)="cancel(false)"
  [contentStyle]="{ 'min-height': '75vh', 'max-height': '85vh' }">
  <ng-template pTemplate="header">
    <div class="title-search" translate>
      exception.title
    </div>
  </ng-template>

  <form #exceptionForm="ngForm" (ngSubmit)="submit(exceptionForm)">
    <div class="pl-2">
      <div class="row pl-2">
        <div class="col-4">
          <span translate>common.date_from</span>
          <p-calendar [(ngModel)]="requestData.startDate" class="w-full" [showIcon]="true"
            [showOnFocus]="false" placeholder="dd-mm-yyyy" dataType="string"
            dateFormat="dd-mm-yy" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
            [required]="true"
            [maxDate]="maxDate"
            (onSelect)="getStartDate()"
            name="startDate" #startDate="ngModel"
            [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange">
          </p-calendar>
          <small class="text-danger" [innerHTML]="(submittedForm && startDate.invalid) ? 'This is required' : '&nbsp;'"></small>
        </div>

        <div class="col-4">
          <span translate>common.date_to</span>
          <p-calendar [(ngModel)]="requestData.endDate" class="w-full" [showIcon]="true"
            [showOnFocus]="false" placeholder="dd-mm-yyyy" dataType="string"
            dateFormat="dd-mm-yy" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
            [minDate]="minDate"
            (onSelect)="getEndDate()"
            [required]="true"
            name="endDate" #endDate="ngModel"
            [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange">
          </p-calendar>
          <small class="text-danger" [innerHTML]="(submittedForm && endDate.invalid) ? 'This is required' : '&nbsp;'"></small>

        </div>
      </div>
      <div class="row pl-2">
        <h3 class="title-select col-11">
          Select user
        </h3>
      </div>
      <div class="col-12">
        <div class="" id="printForm">
          <p-table [value]="userList" [paginator]="showPagination" [lazy]="true" id="user-list-table"
            (onLazyLoad)="pageChangeEvent($event)" [rows]="pageSize" [totalRecords]="totalElements"
            [scrollable]="true"
            [lazyLoadOnInit]="false"
            [(selection)]="requestData.userIds"
            [rowsPerPageOptions]="[10,25,50,100]"
            [currentPageReportTemplate]="'{currentPage} of {totalPages}'"
            [showCurrentPageReport]="true">
            <ng-template pTemplate="header">
              <tr class="theader">
                <th class="maxWidth"></th>
                <th id="username" translate>user_mngt.username</th>
                <th id="firstName" translate>user_mngt.firstname</th>
                <th id="lastName" translate>user_mngt.lastname</th>
                <th id="role" translate>user_mngt.role</th>
              </tr>
              <tr class="theader">
                <td class="maxWidth"></td>
                <td>
                  <app-input-search
                    [value]="searchingItem.username"
                    (onChangeValue)="searchingItem.username=$event"
                    (onTriggerSearch)="autoSearchTrigger()">
                  </app-input-search>
                </td>
                <td>
                  <app-input-search
                    [value]="searchingItem.firstName"
                    (onChangeValue)="searchingItem.firstName=$event"
                    (onTriggerSearch)="autoSearchTrigger()">
                  </app-input-search>
                </td>
                <td>
                  <app-input-search
                    [value]="searchingItem.lastName"
                    (onChangeValue)="searchingItem.lastName=$event"
                    (onTriggerSearch)="autoSearchTrigger()">
                  </app-input-search>
                </td>
                <td class="roleFilter">
                  <div class="input-group">
                    <p-multiSelect
                      [filter]="false"
                      [showClear]="true"
                      [options]="permissionList"
                      [(ngModel)]="selectedRoles"
                      [ngModelOptions]="{standalone: true}"
                      optionValue="id"
                      appendTo="body"
                      optionLabel="name"
                      (onBlur)="autoSearchTrigger()"
                    ></p-multiSelect>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr class="selectable-row border-bottom-default tbody {{selectedUser && selectedUser.id==item.id?'selected-item':''}}">
                <td class="maxWidth">
                  <p-tableCheckbox [value]="item.id"></p-tableCheckbox>
                </td>
                <td> <span>{{item.username}}</span>
              </td>
              <td>
                <span>
                  {{item.firstName}}
                </span>
              </td>
              <td>
                <span>
                  {{item.lastName}}
                </span>
              </td>
              <td class="roleItem">
                @for (role of (item.userGroups | slice : 0 : 2); track role; let last = $last) {
                  {{ role.name }}{{ last ? '' : ', ' }}
                }
                @if (item.userGroups.length > 2) {
                  <span class="d-inline-block dottes"
                    pTooltip="{{getRolesTooltip(item.userGroups)}}" tooltipPosition="top" [tooltipStyleClass]="'custom-tooltip'">
                    <img src="assets/img/more.svg" alt="" width="26">
                  </span>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>


    <div class="w-100 pb-4 mt-5">
      <div class="formgrid grid justify-content-center">
        <div class="field flex">
          <app-button id="createNewException" buttonClass="btn-primary" [isDisabled]="!requestData?.userIds.length"
            buttonType="submit">
            <span translate>buttons.save</span>
          </app-button>
          <app-button id="cancelNewException" buttonClass="btn-secondary mr-0"
            buttonType="button" (clickEvent)="cancel(false)">
            <span translate>buttons.cancel</span>
          </app-button>
        </div>
      </div>
    </div>
  </div>
</form>

</p-dialog>